import { motion } from "framer-motion";

export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  center = false,
  light = false,
  testid,
}) {
  const titleColor = light ? "text-white" : "text-slate-900";
  const subColor = light ? "text-slate-300" : "text-slate-600";
  const eyebrowColor = light ? "text-blue-300" : "text-blue-600";

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}
      data-testid={testid}
    >
      {eyebrow && (
        <p className={`text-xs font-bold tracking-[0.25em] uppercase mb-3 ${eyebrowColor}`}>
          {eyebrow}
        </p>
      )}
      <h2 className={`text-4xl sm:text-5xl font-semibold tracking-tight ${titleColor}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base sm:text-lg leading-relaxed ${subColor}`}>{subtitle}</p>
      )}
    </motion.div>
  );
}
